import ScalarIconPlus_vue_vue_type_script_setup_true_lang_default from "./ScalarIconPlus.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconPlus.vue
var ScalarIconPlus_default = ScalarIconPlus_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconPlus_default as default };

//# sourceMappingURL=ScalarIconPlus.js.map